import api from '@pray/shared/utils/api';

export type CampaignStatus = 'draft' | 'active' | 'paused' | 'completed' | 'system';

export type SpendTimeSeriesCampaign = {
  campaign_id: number;
  campaign_uuid: string;
  campaign_name: string;
  status: CampaignStatus;
  start_date: string | null;
  end_date: string | null;
  spend_by_period: number[];
  cost_by_period?: number[];
  actual_cost_by_period?: number[];
  fee_by_period?: number[];
  total_spend_cents: number;
};

export type SpendTimeSeriesResponse = {
  periods: string[];
  artists: Array<{
    artist_id: number;
    artist_name: string;
    status?: CampaignStatus;
    spend_by_period: number[];
    total_spend_cents: number;
    cost_by_period?: number[];
    actual_cost_by_period?: number[];
    fee_by_period?: number[];
    campaigns?: SpendTimeSeriesCampaign[];
  }>;
  totals_by_period: number[];
  grand_total_cents: number;
  totals_cost_by_period?: number[];
  totals_actual_cost_by_period?: number[];
  totals_fee_by_period?: number[];
};

export type SpendTimeSeriesParams = {
  artistId: string;
  dateRangeStart: string;
  dateRangeEnd: string;
  granularity: 'hour' | 'day' | 'week' | 'month';
};

export const getSpendTimeSeries = async ({
  artistId,
  dateRangeStart,
  dateRangeEnd,
  granularity,
}: SpendTimeSeriesParams) => {
  const params: Record<string, string> = {
    date_range_start: dateRangeStart,
    date_range_end: dateRangeEnd,
    granularity,
  };

  const url = `/web/studio/artists/${artistId}/marketing-impressions/analytics/spend-timeseries`;
  const response = await api.executeGetRequest(url, params);

  return (response.data as any)?.data as SpendTimeSeriesResponse;
};
